// Страница-редирект: устанавливает выбранный тип упражнений в store и перенаправляет на ExercisesManagePage.

import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import useExerciseStore from '../../store/exerciseStore';

/**
 * Редирект-прокси: устанавливает выбранный тип в store и перенаправляет
 * на единую страницу управления упражнениями /teacher/exercises.
 */
export default function TeacherExercisesPage() {
  const { typeId } = useParams();
  const navigate = useNavigate();
  const setTeacherSelectedTypeId = useExerciseStore((s) => s.setTeacherSelectedTypeId);

  useEffect(() => {
    if (typeId) {
      setTeacherSelectedTypeId(Number(typeId));
    }
    navigate('/teacher/exercises', { replace: true });
  }, []);

  return null;
}
